import $ from 'jquery';

export default () => {
    $('.image').find('img').on('error', function () {
        $(this).attr('src', 'http://b.fastcompany.net/asset_files/-/2015/11/16/missing-img.png');
    });
};
